import React from 'react'
import {Box} from 'grommet'
import CreateCommodityForm from '../../../components/createCommodityForm'
import {Storage} from 'aws-amplify';
import { v4 as uuidv4 } from 'uuid';
import { API,Auth } from 'aws-amplify';
import { NavigationSnackBar } from '../../../components/utils/shared/shared';
import {APIRequest} from '../../../components/utils/shared/requests'

class CreateCommodity extends React.Component {

    state = {
        load: false,
        labs: [],
        lab: {},
        value: {display_name: '', name: '', description: '', code: '', documents_key: '', weight: '', length: '', width: '', height:'', customs_value: '',lab_owner_id:0},
        documents: null,
        key: uuidv4()
    }

    componentDidMount(){
      APIRequest('/labs').then(result => this.setState({labs: result}))
    }

    setOwner = (event) => {
      var commodity = this.state.value
      commodity.lab_owner_id = event.value.id
      this.setState({value: commodity, lab: event.value})
    }

    handleValueChange = (event) => {
        this.setState({value: event});
      };

      handleDocsChange = (event) => {
        this.setState({documents: event.target.files})
      };

      setLabs = (event) => {
        this.setState({labs: event})
      }


      uploadToS3 = (files) => {
        const file = files[0]
        const fileName = files[0].name
        Storage.put(`${this.state.key}/${fileName}`,file, {
            contentType: 'application/pdf'
        })
        .then (result => {
          console.log(result)
        }) 
        .catch(err => console.log(err));
      }
    
    returnPieceDetails = (commodity) => {
      var newCommodity = commodity
      var dimensions = {Length: newCommodity.length, Width: newCommodity.width, Height: newCommodity.height}
      var piece = {DimensionsUnit: "CM", WeightUnit: "KG", Weight: newCommodity.weight, Dimensions: dimensions, CustomsValue: newCommodity.customs_value, CustomsValueCurrency: "USD"}
      delete newCommodity['length']
      delete newCommodity['weight']
      delete newCommodity['width']
      delete newCommodity['height']
      delete newCommodity['customs_value']
      newCommodity.default_piece = piece
      this.setState({value: newCommodity})
    }

    handleSubmit = () => {
       const commodity = this.state.value
        this.setState({load: true})
        this.returnPieceDetails(this.state.value)
        if (this.state.documents != null){
          this.uploadToS3(this.state.documents)
          commodity.documents_key = this.state.key
        }
        Auth.currentSession().then(session => {
          API
          .post("LabShip", `/commodities`,
          { headers: { 
            Authorization: session.idToken.jwtToken,
          }, 
          body:{commodity: commodity}})
          .then(shipment => {
           this.setState({load: false})
           this.props.history.push({pathname: '/admin/commodities/all', commSucc:true, edit: false})
         })
        })
      }
    
    render(){
        const {load,value,labs,lab} = this.state;
        return ( 
          <Box>
            <NavigationSnackBar title={'Create Commodity'} user={this.props.user} pages={[{name: 'Dashboard',link: '/dashboard'},{name: 'Commodities', link: '/commodities/all'}]}  />
            <Box alignSelf='center' elevation='medium' direction='column' margin='small' round width='xxlarge'>
                <CreateCommodityForm setOwner={this.setOwner} setLabs={this.setLabs} lab={lab} labs={labs} handleSubmit={this.handleSubmit} handleChange={this.handleValueChange} value={value} load={load} handleDocsChange={this.handleDocsChange}/>
            </Box>
            </Box>

          )
    }
}

export default CreateCommodity
